import APIClient from '@/shared/http/clients/api'

const resourceName = 'departamento'
const APICore = process.env.APIBaseURLCore

const GetAllByCompany = (companyID, data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/empresa/${companyID}`, data, config)
const GetAllPagingByCompany = (companyID, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/empresa/${companyID}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)

const DepartmentRepository = {
  GetAllByCompany,
  GetAllPagingByCompany,
  GetById,
  Create,
  Update,
  Delete
}

export default DepartmentRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configuration/department.js